import { Box, Button, Icon, IconButton, Typography } from "@mui/material";
import React, { useContext, useState } from "react";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Grids from "../../components/grids";
import AddIcon from "@mui/icons-material/Add";
import AddUser from "../../components/modals/adduser";
import AuthContext from "../../contexts/authContext";
import axiosInstance from "../../api/axios";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import toast from "react-hot-toast";
import ViewUser from "../../components/modals/viewUser";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
const Users = () => {
  const { userData, setRefresh } = useContext(AuthContext);
  const [openUser, setOpenUser] = useState(false);
  const [editId, setEditId] = useState("");
  const [openViewUser, setOpenViewUser] = useState(false);
  const [userId, setUserId] = useState("");
  const role = localStorage.getItem("role");
  const handleViewUser = (id) => {
    setUserId(id);
    setOpenViewUser(true);
  };
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRowId, setSelectedRowId] = useState(null);

  const openMenu = Boolean(anchorEl);

  const handleOpenMenu = (event, id) => {
    setAnchorEl(event.currentTarget);
    setSelectedRowId(id);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
    setSelectedRowId(null);
  };

  const columns = [
    {
      field: "id",
      headerName: "S.No",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      align: "center",
      minWidth: 80,
      maxWidth: 80,
      flex: 1,
    },
    {
      field: "name",
      headerName: "Name",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      align: "left",
      minWidth: 150,
      maxWidth: 180,
      flex: 1,
    },
    {
      field: "usertype",
      headerName: "Type",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      align: "center",
      minWidth: 130,
      maxWidth: 130,
      flex: 1,
    },
    {
      field: "mobile",
      headerName: "Mobile",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      align: "center",
      minWidth: 120,
      maxWidth: 120,
      flex: 1,
    },
    {
      field: "username",
      headerName: "Username",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      minWidth: 150,
      maxWidth: 180,
      flex: 1,
    },
    {
      field: "area",
      headerName: "Area",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      align: "center",
      minWidth: 180,
      flex: 2,
      renderCell: (params) => {
        return (
          <Box
            sx={{
              display: "flex",
              gap: 1,
              alignItems: "center",
              justifyContent: "center",
              height: "100%",
              flexWrap: "wrap",
              overflowY: "auto",
              py: 1,
            }}
          >
            {params.row.area.map((item) => (
              <Typography
                key={item._id}
                sx={{
                  backgroundColor: "#800001",
                  color: "#fff",
                  px: 1,
                  py: 0.2,
                  borderRadius: 5,
                }}
              >
                {item.areaName}
              </Typography>
            ))}
          </Box>
        );
      },
    },
    {
      field: "actions",

      headerName: "Actions",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      align: "center",
      flex: 1,
      minWidth: 130,
      maxWidth: 130,

      // renderCell: (params) => (
      //   <Box
      //     sx={{
      //       display: "flex",
      //       justifyContent: "center",
      //       alignItems: "center",
      //       height: "100%",
      //     }}
      //   >
      //     <IconButton
      //       sx={{
      //         color: "#800001",
      //         "&:hover": {
      //           backgroundColor: "#800001",
      //           color: "#fff",
      //         },
      //       }}
      //       onClick={() => handleViewUser(params.row._id)}
      //     >
      //       <Icon>
      //         <VisibilityIcon />
      //       </Icon>
      //     </IconButton>

      //     <IconButton
      //       sx={{
      //         color: "#800001",
      //         "&:hover": {
      //           backgroundColor: "#800001",
      //           color: "#fff",
      //         },
      //       }}
      //       onClick={() => handleOpenEditUser(params.row._id)}
      //     >
      //       <Icon>
      //         <EditIcon />
      //       </Icon>
      //     </IconButton>

      //     <IconButton
      //       sx={{
      //         color: "#800001",
      //         "&:hover": {
      //           backgroundColor: "#800001",
      //           color: "#fff",
      //         },
      //       }}
      //       onClick={() => handleDeleteUser(params.row._id)}
      //     >
      //       <Icon>
      //         <DeleteIcon />
      //       </Icon>
      //     </IconButton>
      //   </Box>
      // ),
      renderCell: (params) => (
        <IconButton
          onClick={(e) => handleOpenMenu(e, params.row._id)}
          sx={{ color: "#800001" }}
        >
          <MoreVertIcon />
        </IconButton>
      ),
    },
  ];
  const rows = userData?.users
    ?.filter((use) => use.status !== "erased")
    .map((item, index) => ({
      id: index + 1,
      _id: item._id,
      name: item.name,
      mobile: item.mobile,
      username: item.username,
      area: item.areas,
      status: item.status,
      usertype: item.role,
    }));

  const handleDeleteUser = async (id) => {
    if (!window.confirm("Do you want to delete this user?")) return;

    const res = await axiosInstance.delete(`/users/delete/${id}`);
    if (res.status === 200) {
      toast("User deleted successfully");
      setRefresh(true);
    } else {
      toast.error("Failed to delete user");
    }
  };
  const handleOpenEditUser = (id) => {
    setEditId(id);
    setOpenUser(true);
  };
  return (
    <>
      <Typography
        variant="h5"
        color="#800001"
        sx={{ fontWeight: "400", textAlign: "center", mb: 2 }}
      >
        Users
      </Typography>
      <Box
        sx={{
          display: "flex",
          gap: 2,
          mb: 2,
          justifyContent: "space-between",
          padding: "10px",
          flexWrap: "wrap",
          alignItems: "center",
        }}
      >
        <Button
          sx={{
            display: "flex",
            gap: 1,
            backgroundColor: "#800001",
            color: "white",
            padding: "10px",
          }}
          onClick={() => setOpenUser(true)}
        >
          <AddIcon sx={{ fontSize: "24px" }} />
          <Typography
            variant="p"
            sx={{
              fontSize: "14px",
              fontFamily: "sans-serif",
              fontWeight: 500,
              display: { xs: "none", sm: "block" },
            }}
          >
            Add User
          </Typography>
        </Button>
        {/* <TextField
          placeholder="Search"
          variant="outlined"
          sx={{
            width: { xs: "240px", sm: "300px" },
            "& .MuiOutlinedInput-input": {
              padding: "10px",
              color: "#800001",
            },
            "& .MuiInputLabel-root": {
              color: "#800001",
            },
            "& .MuiInputLabel-shrink": {
              color: "#800001",
            },
            "& .MuiOutlinedInput-root": {
              "& fieldset": {
                borderColor: "#800001", // Default border
              },
              "&:hover fieldset": {
                borderColor: "#cc0000", // On hover
              },
              "&.Mui-focused fieldset": {
                borderColor: "#800001", // On focus
              },
            },
          }}
        /> */}
      </Box>
      <Box sx={{ width: { xs: "95vw", sm: "81vw" } }}>
        <Grids columns={columns} rows={rows} />
      </Box>
      <AddUser
        openUser={openUser}
        setOpenUser={setOpenUser}
        editId={editId}
        setEditId={setEditId}
      />
      <ViewUser
        openViewUser={openViewUser}
        setOpenViewUser={setOpenViewUser}
        userId={userId}
        setUserId={setUserId}
      />
      <Menu anchorEl={anchorEl} open={openMenu} onClose={handleCloseMenu}>
        <MenuItem
          sx={{
            color: "#800001",
            "&:hover": { backgroundColor: "#800001", color: "#fff" },
          }}
          onClick={() => {
            handleViewUser(selectedRowId);
            handleCloseMenu();
          }}
        >
          <VisibilityIcon fontSize="small" style={{ marginRight: 8 }} />
          View
        </MenuItem>

        {role === "admin" && (
          <MenuItem
            sx={{
              color: "#800001",
              "&:hover": { backgroundColor: "#800001", color: "#fff" },
            }}
            onClick={() => {
              handleOpenEditUser(selectedRowId);
              handleCloseMenu();
            }}
          >
            <EditIcon fontSize="small" style={{ marginRight: 8 }} />
            Edit
          </MenuItem>
        )}

        {role === "admin" && (
          <MenuItem
            sx={{
              color: "#800001",
              "&:hover": { backgroundColor: "#800001", color: "#fff" },
            }}
            onClick={() => {
              handleDeleteUser(selectedRowId);
              handleCloseMenu();
            }}
          >
            <DeleteIcon fontSize="small" style={{ marginRight: 8 }} />
            Delete
          </MenuItem>
        )}
      </Menu>
    </>
  );
};

export default Users;
